export default "__VITE_PUBLIC_ASSET__a7259b1e__"